import type { JSX } from 'react'
import React, { useEffect, useState } from 'react'
import MediaDrawer from '../MediaDrawer'
import MediaCarousel from '../MediaCarousel'
import SlidesProgress from '../SlidesProgress'
import Button from '@bt-react/components/Button'
import TooltipWrapper from '@bt-react/components/TooltipWrapper'
import slidesDrawerStyles from './SlidesDrawer.module.scss'
import { IconType } from '@bt-react/components/Icon'
import { SlideCardData, SlidesDrawerProps } from './types'
import SlideCard from './SlideCard'
import usePrevious from '@bt-react/libs/usePrevious'
import isEqual from 'lodash/isEqual'

const SlidesDrawer: React.FC<SlidesDrawerProps> = (props) => {

  const [ slides, setSlides ] = useState<JSX.Element[]>([])
  const prevSlides = usePrevious(props.slides)

  useEffect(() => {

    if (isEqual(prevSlides, props.slides)) return

    setSlides(props.slides.map(
      (slide: SlideCardData, i) => <SlideCard
        key={i}
        url={slide.url}
        index={i + 1}
        selected ={false}
        onClick={props.onSlideClick}
        presenterLayoutActive={props.presenterLayoutActive}
        mediaType={props.mediaType}
      />))

  }, [ props.slides, props.onSlideClick, prevSlides, props.presenterLayoutActive, props.mediaType ])

  const selectedItem = props.selectedSlide === null ? -1 : props.selectedSlide - 1

  const getButton = () => {

    return props.slides.length === 0 ?
      (
        props.isLoading ?
        <TooltipWrapper
          position='left'
          tooltipText='Upload in progress. Please wait.'
          dataBdd='add-slides-button'
        >
          <Button
            disabled={true}
            color={IconType.colour.secondary}
            onClick={undefined}
            text='Add slides'
            dataBdd='slides-add-manage-btn'
          />
        </TooltipWrapper>
        : <Button
            color={IconType.colour.secondary}
            onClick={props.onAddClick}
            text='Add slides'
            dataBdd='slides-add-manage-btn'
          />
      ) :
      <Button
        color={IconType.colour.secondary}
        onClick={props.onRemoveClick}
        text='Remove slides'
        dataBdd='slides-remove-btn'
      />
  }

  return (
    <MediaDrawer
      title='Slides'
      onClick={props.onClick}
      dataBdd='slides'
      hidden={props.hidden ?? true}
      action={getButton()}
    >
      {props.isLoading
        ? <SlidesProgress />
        : <MediaCarousel
          empty={{
            icon: IconType.iconName.image,
            message: 'No slides added'
          }}
          items={slides}
          selected={selectedItem}
          hidden={props.hidden ?? true}
        />}
    </MediaDrawer>)

}

export default SlidesDrawer
